import { getClientReferrer } from './getClientReferrer'

const GOOGLE_HOSTNAME = /^([a-z0-9-]+\.)*google\.[a-z.]+$/i

export const isGoogleReferrer = (): boolean => {
    if (typeof document === 'undefined') {
        return false
    }

    const referrer = getClientReferrer()

    if (!referrer) {
        return false
    }

    try {
        return GOOGLE_HOSTNAME.test(new URL(referrer).hostname.toLowerCase())
    } catch {
        return false
    }
}
